import _regeneratorRuntime from "@babel/runtime/regenerator";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { Head } from '@inertiajs/inertia-vue3';
import Icon from '@/Shared/Icon';
import pickBy from 'lodash/pickBy';
import Layout from '@/Shared/Layout';
import throttle from 'lodash/throttle';
import mapValues from 'lodash/mapValues';
import Pagination from '@/Shared/Pagination';
import SearchFilter from '@/Shared/SearchFilter';
import { Link } from '@inertiajs/inertia-vue3';
export default {
  components: {
    Head: Head,
    Icon: Icon,
    Pagination: Pagination,
    SearchFilter: SearchFilter,
    Link: Link
  },
  layout: Layout,
  props: {
    tenant_data: Object,
    internalTenants: Object
  },
  data: function data() {
    return {
      form: {
        tenant: null,
        member: null,
        date: null,
        campaign: null,
        industry: null,
        sub_industry: null,
        department: null,
        title: null,
        location: null
      },
      selected_field: 'industry',
      tenant_details: this.tenant_data
    };
  },
  methods: {
    resetSearch: function resetSearch() {
      var changeTenant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var formData = {
        tenant: this.form.tenant,
        member: null,
        date: null,
        campaign: null,
        industry: null,
        sub_industry: null,
        department: null,
        title: null,
        location: null
      };
      if (!changeTenant) {
        formData.tenant = null;
      }
      this.form = formData;
      this.getParameterData();
    },
    getParameterData: function getParameterData() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$store.loading = true;
                _context.next = 3;
                return axios.post('/get_parameter_data', _this.form);
              case 3:
                res = _context.sent;
                _this.tenant_details = res.data;
                _this.$store.loading = false;
              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};